import { render, staticRenderFns } from "./StoreViewItem.vue?vue&type=template&id=8c397f38&scoped=true"
import script from "./StoreViewItem.vue?vue&type=script&lang=js"
export * from "./StoreViewItem.vue?vue&type=script&lang=js"
import style0 from "./StoreViewItem.vue?vue&type=style&index=0&id=8c397f38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c397f38",
  null
  
)

export default component.exports